import { z } from 'zod';

/**
 * UAE TRN — IBR-148-AE: 15 numeric chars, must start with '1'.
 * Source: Solara spec § Adatszótár 3.1, code E001.
 */
export const TrnSchema = z
  .string()
  .regex(/^1\d{14}$/u, { message: 'E001' })
  .brand<'TRN'>();
export type Trn = z.infer<typeof TrnSchema>;

/**
 * Peppol Participant ID for UAE = `0088:AETRN<15-digit TRN>`.
 */
export const PeppolParticipantIdSchema = z
  .string()
  .regex(/^0088:AETRN1\d{14}$/u, { message: 'E050' });
export type PeppolParticipantId = z.infer<typeof PeppolParticipantIdSchema>;

export const IsoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/u, { message: 'E002' });
export type IsoDate = z.infer<typeof IsoDateSchema>;

export const IsoUtcTimestampSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/u, { message: 'E008' });

/** ISO 4217 currency, 3 uppercase letters. */
export const CurrencySchema = z
  .string()
  .regex(/^[A-Z]{3}$/u, { message: 'E020' })
  .brand<'Currency'>();
export type Currency = z.infer<typeof CurrencySchema>;

export const VatRateSchema = z.union([
  z.literal(5),
  z.literal(0),
  z.literal('EXEMPT'),
]);
export type VatRate = z.infer<typeof VatRateSchema>;

/** UAE phone — E.164 international format. */
export const PhoneSchema = z
  .string()
  .regex(/^\+[1-9]\d{7,14}$/u, { message: 'E011' });

export const EmailSchema = z
  .string()
  .regex(/^[^@\s]+@[^@\s]+\.[^@\s]+$/u, { message: 'E010' });

export const TenantIdSchema = z.string().uuid();
export type TenantId = z.infer<typeof TenantIdSchema>;

export const InvoiceIdSchema = z.string().uuid();
export type InvoiceId = z.infer<typeof InvoiceIdSchema>;
